import React from 'react'

function Footer() {
  return (
    <div className="container-fluid d-flex justify-center justify-content-center text-white align-items-center flex-wrap bg-dark p-3">
        © 2022
            <a href="https://github.com/himanshu608" className='text-info mx-4 text-decoration-none'><span>Himanshu Verma</span></a>
            <a href="https://github.com/MiraclePlusPlus" className='text-info text-decoration-none'><span>Pushkaraj Salunke</span></a>

    </div>
  )
}

export default Footer